module.exports = __webpack_public_path__ + "static/img/ent-36.5ca2ab3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-36.jpg
// module id = dzTb
// module chunks = 52